import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import { BorderBottom } from '@/components/uikit';
import { Delivery, SubscriptionStatusString } from '@/types';
import { ReactComponent as AlaramSvg } from '@/assets/images/alarm.svg';
import { HeaderLabel } from './HeaderLabel';

interface Props {
  delivery: Delivery;
  status: SubscriptionStatusString;
  isSelfPickup: boolean;
}

export function DeliveryInfo({ delivery, status, isSelfPickup }: Props) {
  const { courier, shipment_type } = delivery;
  return (
    <Box bgcolor="white" p={2}>
      <HeaderLabel>Informasi Pengiriman</HeaderLabel>
      <BorderBottom />

      <Typography style={{ fontSize: 14, opacity: 0.7, marginTop: 16 }}>
        Metode Pengiriman
      </Typography>
      {isSelfPickup ? (
        <Typography>Diambil di Apotek (Self Pickup)</Typography>
      ) : (
        <>
          <Typography>
            {courier.name} - {shipment_type.name}
          </Typography>

          {status !== 'order_processed' && (
            <>
              <Typography style={{ fontSize: 14, opacity: 0.7, marginTop: 16 }}>
                Nomor AWB
              </Typography>
              <Typography>{courier.waybill_id || '-'}</Typography>

              <Typography style={{ fontSize: 14, opacity: 0.7, marginTop: 16 }}>
                Nama Kurir
              </Typography>
              <Typography>
                {courier.driver_name} - {courier.driver_phone_number}
              </Typography>

              <Typography style={{ fontSize: 14, opacity: 0.7, marginTop: 16 }}>
                Tracking Link
              </Typography>
              <a href={courier.link} style={{ textDecoration: 'none' }}>
                <Typography color="primary">{courier.link || '-'}</Typography>
              </a>
            </>
          )}

          {delivery.courier.is_error === true && (
            <Alert
              severity="error"
              style={{ alignItems: 'center', borderRadius: 12, marginTop: 24 }}
              icon={<AlaramSvg />}
            >
              Terdapat kendala dalam pengiriman. Silahkan hubungi PIC Lifepack
              untuk melakukan pengiriman manual
            </Alert>
          )}
        </>
      )}
    </Box>
  );
}
